import React from "react";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";

//Services
import Api from "../../services/api";

//Components
import AddFactory from "../Registration/Factory/addFactory";
import DelFactory from "../Registration/Factory/delFactory";
import AltFactory from "../Registration/Factory/altFactory";
import ReportFactories from "../Reports/reportFactories";
import BottomBar from "../../Components/bottomBar/bottomBar";
import Alert from "../../Components/alert/Alert";
import TopBar from "../../Components/topBar/topBar";
import { DrawerMenu } from "../../Components/DrawerMenu/DrawerMenu";

//Styles
import "./prelude.css";

const prelude_factory = () => {
  const [activeTab, setActiveTab] = React.useState("list");
  return (
    <>
      <header>
        <TopBar></TopBar>{" "}
      </header>
      <div className="prelude_container">
        <DrawerMenu>
          <Sidebar
            isMobile
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></Sidebar>
        </DrawerMenu>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}></Sidebar>
      </div>
      <BottomBar></BottomBar>
    </>
  );
};

class Sidebar extends React.Component {
  state = {
    data: [],
    keys: [],
    render: false,
    message: "",
    click: false,
    controller: "",
    id: "",
  };

  async componentDidMount() {
    let array = [];
    await Api.get("/factorys")
      .then((response) => {
        response.data.forEach((element) => {
          array.push({
            Planta: element.description,
            Código: element.code,
          });
        });
        if (array.length > 0) this.setState({ data: array, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { show, message } = this.state;
    const items = [
      { id: "lg1", label: "Plantas", eventKey: "list" },
      { id: "lg2", label: "Adicionar Planta", eventKey: "add" },
      { id: "lg3", label: "Alterar Planta", eventKey: "alt" },
      { id: "lg4", label: "Deletar Planta", eventKey: "del" },
    ];

    return (
      <Tab.Container activeKey={this.props.activeTab}>
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1 ">
            <div
              className={
                this.props.isMobile ? "sidebar2-mobile" : "sidebar2"
              }
            >
              <Col className="sidebarColumn" mountOnEnter unmountOnExit>
                <ListGroup>
                  {items.map((item) =>
                    this.props.isMobile ? (
                      <Col key={item.id} xs={12}>
                        <ListGroup.Item
                          id={item.id}
                          onClick={() => {
                            this.props.setActiveTab(item.eventKey);
                            this.props.handleClose()
                          }}
                          className="listGroup"
                          eventKey={item.eventKey}
                        >
                          {item.label}
                        </ListGroup.Item>
                      </Col>
                    ) : (
                      <ListGroup.Item
                        key={item.id}
                        id={item.id}
                        onClick={() => {
                          this.props.setActiveTab(item.eventKey);
                        }}
                        className="listGroup d-none d-md-block"
                        eventKey={item.eventKey}
                      >
                        {item.label}
                      </ListGroup.Item>
                    )
                  )}
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col3"
              style={{
                top: "5%",
                marginLeft: "1.5%",
                width: "100%",
               
                overflow: "hidden",
              }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              {!this.props.isMobile && (
                <Tab.Content>
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="list">
                    {this.handleClick ? <ReportFactories /> : null}
                  </Tab.Pane>
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="add">
                    {this.handleClick ? <AddFactory /> : null}
                  </Tab.Pane>
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="alt">
                    {this.handleClick ? <AltFactory /> : null}
                  </Tab.Pane>
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="del">
                    {this.handleClick ? <DelFactory /> : null}
                  </Tab.Pane>
                </Tab.Content>
              )}
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_factory;
